import React, { useState, useEffect, useRef } from "react";
import { Form, Spin } from "antd";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import CustomModal from "@/components/CustomModal";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchStaffGroupById } from "@/apis/security/staffGroupsApi";
import {
  saveClientParam,
  deleteClientParam,
} from "@/apis/config/clientParamsApi";
import { clearCurrentParam } from "@/slices/clientParamsSlice";
import ClientParamsForm from "./StaffGroupForms/ClientParamsForms";
import {
  StyledFlex,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import { setBookings } from "@/slices/bookingsSlice";
import { isNonEmptyVariable } from "@/util/common_function";
import { v4 as uuidV4 } from "uuid";
import _ from "lodash";

const ClientParamsDetails = ({ staffGroupsId, headerSubTitle, disabled = false, bookingsFieldsEnabled }) => {
  const dispatch = useDispatch();
  const tableRef = useRef();
  const [form] = Form.useForm();
  const { showDialog } = useDialog();

  const [mode, setMode] = useState("add"); // "add" | "edit"
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(disabled)

  // const parent = useSelector((s) => s.staffGroups.current);
  const listLoading = useSelector((s) => s.staffGroups.currentLoading);
  const [list, setList] = useState([])

  const current = useSelector((s) => s.clientParams.current);
  const currentLoading = useSelector((s) => s.clientParams.currentLoading);
  const saving = useSelector((s) => s.clientParams.saving);
  const deleting = useSelector((s) => s.clientParams.deleting);
  const { bookings } = useSelector((s) => s?.bookings);

  useEffect(() => {
    if (staffGroupsId != null) {
      // dispatch(fetchStaffGroupById(staffGroupsId));
      // dispatch(clearCurrentParam());
      setSelectedRow(null);
    }
  }, [dispatch]);

  useEffect(() => {
    if (isNonEmptyVariable(bookings?.clientParams)) {
      let allRules = bookings?.clientParams?.map((e, i) => {
        return {
          ...e,
          uuid: uuidV4(),
        }
      })
      console.log(allRules, "allRules")
      if (allRules?.length) {
        setList([...allRules])
      }
      else{
        setList([])
      }
    }
  }, [bookings]);

  const openAdd = () => {
    form.resetFields();
    dispatch(clearCurrentParam());
    setMode("add");
    setModalOpen(true);
    setIsDisabled(false);
  };

  const openEdit = () => {
    if (!selectedRow) return;
    setMode("edit");
    setModalOpen(true);
    setIsDisabled(false);
  };

  const openDetails = () => {
    if (!selectedRow) return;
    setMode("edit");
    setModalOpen(true);
    setIsDisabled(true);
  };

  // open delete confirm
  const openDelete = () => {
    if (!selectedRow) return;
    showDialog("confirm", {
      title: "Are you sure you want to delete this record?",
      onConfirm: () => confirmDelete(),
    });
    // confirmDelete()
  };

  const confirmDelete = () => {
    dispatch(deleteClientParam(selectedRow.clientParamID))
    let newList = _.cloneDeep(list)
    if (newList?.length) {
      newList = newList.filter((e, i) => {
        if (e.uuid != selectedRow?.uuid) {
          return e
        }
      })
      // console.log({ newList })
      dispatch(
        setBookings({
          clientParams: [...newList],
        })
      );
    }
    setSelectedRow(null);
  };

  const handleSave = () => form.submit();

  const handleCloseModal = () => {
    setModalOpen(false);
    tableRef?.current?.resetAll();
  };

  const onFinish = (values) => {
    const payload = {
      ...values,
      staffId: bookings?.staffId,

    };
    // dispatch(saveClientParam(payload)).then(() => {
    //   if (bookings?.staffId)
    //     dispatch(fetchAllSecurityListOfStaff(bookings?.staffId))
    // }
    // );
    let newList = _.cloneDeep(list)
        // console.log({ payload })
        if (mode == "edit") {
          console.log({ selectedRow })
          if (newList?.length) {
            newList = newList.map((e, i) => {
              if (e.uuid == selectedRow?.uuid) {
                console.log({ ...e, ...payload }, "newList")
                return { ...e, ...payload }
              }
              return e
            })
            console.log({ newList })
          } 
        }
        // console.log({ newList })
    
        if (mode == "add") {
          if (newList?.length == 0) {
            newList.push(payload)
            // setList([payload])
          } else {
            console.log({payload})
            newList=[...newList,payload]
            // setList([...list, payload])
          }
        }
        // console.log({list})
        dispatch(
          setBookings({
            clientParams: [...newList],
          })
        );
    handleCloseModal();
  };

  // const list = useSelector((s) => s.staff.clientParams) || [];
  const headers = [
    { key: "paramName", text: "Param Name" },
    { key: "paramContext", text: "Param Context" },
    { key: "paramValue", text: "Param Value" },
  ];

  const onRowClick = (row, index) => {
    setSelectedRow(row);
    if(index !== null && index !== undefined) {
      if(disabled) {
        openEdit();
      } else {
        openDetails();
      }
    }
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Client Parameters</span>
      </StyledSectionHeading>

      <StyledSubTableContainer>
        <StyledFlex gap="10px" justify="space-between">
          <div>
            <h2>{headerSubTitle}</h2>
          </div>
          <StyledFlex gap="10px" marginBottom="8px" marginTop="0px">
            <Button 
              onClick={openAdd}
              loading={saving}
              disabled={disabled}
            >
              <PlusOutlined /> Add
            </Button>
            {/* <Button
              onClick={openDetails}
              disabled={!selectedRow}
              loading={currentLoading}
              style={{ marginLeft: 8 }}
            >
              Details
            </Button>
            <Button
              onClick={openEdit}
              disabled={!selectedRow || !bookingsFieldsEnabled}
              loading={currentLoading}
              style={{ marginLeft: 8 }}
            >
              Modify
            </Button> */}
            <Button
              onClick={disabled ? openEdit : openDetails}
              disabled={!selectedRow}
              loading={currentLoading}
              style={{ marginLeft: 8 }}
            >
              {!disabled ? "Modify" : "Details"}
            </Button>
            <Button
              onClick={openDelete}
              disabled={!selectedRow || disabled}
              loading={deleting}
              style={{ marginLeft: 8 }}
            >
              Delete
            </Button>
          </StyledFlex>
        </StyledFlex>

        <Spin spinning={listLoading}>
          <DataTable
            ref={tableRef}
            headers={headers}
            data={list||[]}
            rowUniqueId="uuid"
            onRowClick={onRowClick}
          />
        </Spin>
      </StyledSubTableContainer>

      {isModalOpen && (
        <CustomModal
          size="lg"
          header="Client Param"
          show={isModalOpen}
          onHide={handleCloseModal}
          onSaveClick={handleSave}
          confirmLoading={saving}
          backdrop={false}
          isDisabled={disabled}
        >
          <ClientParamsForm
            form={form}
            initialValues={mode === "edit" ? selectedRow : {}}
            onFinish={onFinish}
            disabled={currentLoading || !disabled}
          />
        </CustomModal>
      )}
    </>
  );
};

ClientParamsDetails.defaultProps = {
  headerSubTitle: "List of Client Params for this Staff Group",
};

export default ClientParamsDetails;
